import * as Api from '../api.js'
import * as types from './mutation-types'

export const login = (context, {email, password}) => {
  context.commit(types.AUTH_REQUEST)
  Api.login({email, password})
  .then(result => {
    if (result.token) {
      setJwt(context, result.token)
      // getScreens(context, true)
    } else {
      context.commit(types.AUTH_FAILURE)
    }
  })
  .catch(error => {
    context.commit(types.AUTH_FAILURE, error)
  })
}

export const updateJwt = (context) => {
  context.commit(types.AUTH_REQUEST)
  Api.refreshjwt()
  .then(result => {
    if (result.token) {
      setJwt(context, result.token)
    } else {
      context.commit(types.AUTH_FAILURE)
      context.commit(types.LOGOUT_USER)
    }
  })
  .catch(error => {
    if (error.status == 401) {
      context.commit(types.LOGOUT_USER)
    }
    context.commit(types.AUTH_FAILURE, error)
  })
}

function setJwt(context, jwt) {
  context.commit(types.UPDATE_USER_JWT, jwt)
  context.commit(types.AUTH_SUCCESS)

  Promise.all([updateUser(context), updateIsp(context)])
    .then(r => {
      console.log("done!!!")
      context.commit(types.APP_STATE, true)
    })
    .catch(e => {
      console.log("error", e)
    })
  setTimeout(() => {
    updateJwt(context)
  }, 1000 * 60 * 15)
}

export const updateUser = (context) => {
  return Api.user()
    .then(r => {
      context.commit(types.UPDATE_USER, r.data)
    })
    .catch(e => {
      console.log("error", e)
    })
}

export const updateIsp = (context) => {
  return Api.isp()
    .then(r => {
      context.commit(types.UPDATE_ISP, r.data)
    })
    .catch(e => {
      console.log("error", e)
    })
}